export default "__VITE_ASSET__eikribsO__"